<script setup>
import { ref } from 'vue'
import { Button } from "@/components/ui/button"
import { get_data_attr, formatNameForUser } from '@/utils/globals'
import { useI18n } from 'vue-i18n';


const { t } = useI18n();

// Props: existing comments
defineProps({
  comments: {
    type: Array,
    default: () => []
  },
  userName: {
    type: String,
    default: 'Anonymous'
  },
  disabled: {
	type: Boolean,
	default: true,
  }
})

// Emits: new comment added
const emit = defineEmits(['add-comment'])

const userInfo = get_data_attr("user");

const newComment = ref('')

function addComment() {
  if (newComment.value.trim() === '') return
  const commentObj = {
    content: newComment.value.trim(),
	user: userInfo,
    created_at: new Date().toISOString()
  }
  emit('add-comment', commentObj)
  newComment.value = ''
}
</script>

<template>
  <div class="flex flex-col h-full border rounded p-4">
    <div class="flex-1 overflow-auto space-y-2 mb-4">
      <div
        v-for="(comment, index) in comments"
        :key="index"
        class="border-b pb-2"
      >
        <div class="text-sm text-gray-500">
          {{ formatNameForUser(comment.user)}} • 
          {{ new Date(comment.created_at).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) }}
        </div>
        <div class="text-gray-800">{{ comment.content }}</div>
      </div>
    </div>

    <div class="flex gap-2">
      <input
	    :disabled="disabled"
        v-model="newComment"
        type="text"
        :placeholder="t('view.addcomment')"
        class="flex-1 border rounded px-2 py-1"
        @keyup.enter="addComment"
      />
      <Button :disabled="disabled" @click="addComment" class="h-9">{{ t('view.add') }}</Button>
    </div>
  </div>
</template>
